<!--suppress UnnecessaryLabelJS -->
<template>
	<div>
		<table-filter
			@search="searchText = $event"
			@chosen-tags="chosenTags = $event"
      :show-types="false"
		/>
		<v-data-table
			:headers="headers"
			:items="questionsFiltered"
			:loading="loading"
			class="elevation-1"
			:search="searchText"
			:custom-filter="searchWithCompany"
			:mobile-breakpoint="0"
		>
			<v-progress-linear
				slot="progress"
				color="blue"
				indeterminate
			/>
			<question-row
				slot="item"
				slot-scope="props"
				:question="props.item"
				@edit="onEdit"
			/>
		</v-data-table>
	</div>
</template>

<script>
import QuestionRow from "./QuestionRow";
import {types as questionTypes} from "../../store/Question.module";
import TableFilter from "src/components/TableFilter";
import FilterAble from "dev/mixins/FilterAble";

export default {
	name: "QuestionsTable",
	components: {
		QuestionRow,
		TableFilter,
	},
	props: [],
	mixins: [new FilterAble(questionTypes)],
	data () {
		return {
			loading: false,
			headers: [
				{ text: "מזהה שאלה", value: "id" },
				{ text: "תוכן השאלה", value: "question" },
        { text: "מזהה תשובה", value: "answer.content" },
				{ text: "סוג שאלה", value: "question_type" },
				{ text: "תגיות", value: "tags" },
				{ text: "מרכז", value: "company" },
				{ text: "פעולות", value: "", sortable: false },
				// {text: "is_true_false_question", value: "is_true_false_question"},
				// {text: "true_false_answer", value: "true_false_answer"},
				// {text: "before_question", value: "before_question"},
				// {text: "before_question_type", value: "before_question_type"},
				// {text: "after_answer", value: "after_answer"},
				// {text: "after_answer_type", value: "after_answer_type"},
				// {text: "timer", value: "timer"},
			],
			searchText: null,
			chosenTags: [],
			showDialog: false,
		};
	},
	computed: {
		questions () {
			return this.$store.state.QuestionModule.questions;
		},
		questionsFiltered () {
			if (!this.chosenTags.length) {
				return this.questions;
			} else {
				return this.questions.filter((question) => {
          return question.tags &&
              question.tags.filter((tag) => {
                return this.chosenTags.includes(tag.id);
              }).length;
				});
			}
		},
	},
	methods: {
		searchWithCompany (value, search, item) {
			if (typeof value === "object" && value !== null && value.name) {
				return value.name.indexOf(search) !== -1;
			} else {
				return (
					value != null &&
					search != null &&
					typeof value === "string" &&
					value.toString().indexOf(search) !== -1
				);
			}
		},
		onEdit (question) {
			this.$emit("edit", question);
		},
	},
};
</script>

<style>
</style>
